import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Logger } from '@core/services/logger.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Placement } from 'src/app/core/models/placement.model';

@Component({
	selector: 'cass-order-select-placement',
	templateUrl: './select-placement.component.html',
	styleUrls: ['./select-placement.component.css']
})
export class SelectPlacementComponent implements OnInit, OnDestroy {

	private readonly COMPONENT_NAME = "SelectPlacementComponent";

	@Input()
	placements?: Placement[];

	@Input()
	selectedPlacement?: Placement;

	@Output()
	placementChanged = new EventEmitter<Placement>();

	private placementSelectedSubject = new Subject<Placement>();
	private subscription: Subscription = Subscription.EMPTY;

	constructor(private logger: Logger) { }

	ngOnInit(): void {
		this.subscription = this.placementSelectedSubject.pipe(debounceTime(300)).subscribe((placement) => {
			this.placementChanged.emit(placement);
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	selectPlacement(placement: Placement) {
		this.logger.debug(this.COMPONENT_NAME, `Selecting placement id="${placement?.id}" label="${placement?.label}"`);
		this.selectedPlacement = placement;

		this.placementSelectedSubject.next(this.selectedPlacement);
	}
}
